import { memo, useMemo, useState, useEffect, useCallback } from 'react'
import { withRouter } from 'react-router-dom'
import CommonFunc from '@/utils/common-func'
import BaseModal from '@/components/BaseModal/BaseModal'
import BasePopconfirm from '@/components/BasePopconfirm/BasePopconfirm'
import { useAbortableRequest } from '@/hooks/useAbortableRequest'
import { sessionStore } from '@/utils/storage'
import { Button, message } from 'antd'
import { PaperItem, TYPE_LIST, DocTypeLabelMap, TABS } from './const'
import { eventBus } from '@/utils/eventBus'
import './LunwenManage.less'

const LunwenManage = ({ history, visible, onGetType, onCancel, onOk }: any) => {
  const token = localStorage.getItem('uniToken')
  const { sendRequest } = useAbortableRequest()
  const [activeTab, setActiveTab] = useState('paid')
  const [activeType, setActiveType] = useState(0)
  const [data, setData] = useState<any>({ unpaid: [], paid: [] })
  const list = useMemo(() => {
    if (activeType == 0) {
      return data?.[activeTab] || []
    }
    return data?.[activeTab]?.filter((item: any) => item.type === activeType) || []
  }, [data, activeTab, activeType])
  useEffect(() => {
    work_list()
  }, [])
  const work_list = async () => {
    const result: any = await sendRequest({ method: 'post', url: 'work_list', data: {} })
    if (result?.res) {
      setData(result.res.data)
    }
  }
  // 使用 useCallback 优化性能
  const handleTabChange = useCallback((type: string) => {
    setActiveTab(type)
  }, [])

  const handleTypeChange = useCallback((type: number) => {
    setActiveType(type)
  }, [])

  const handleContinueEdit = async (item: PaperItem) => {
    const result: any = await sendRequest({ method: 'post', url: 'work_data', data: { work_id: item.work_id } })
    if (result?.res) {
      const data = result?.res?.data
      for (const key in data) {
        if (data[key] === null || data[key] === '') {
          delete data[key]
        }
        if (['updated_at', 'created_at', 'updated_at'].includes(key)) {
          delete data[key]
        }
        const deleteKeys = ['expend_count', 'payment_state', 'expend_aigc', 'expend_repeat']
        if (deleteKeys.includes(key) && data[key] === 0) {
          delete data[key]
        }
        if (key == 'type') {
          data[key] = String(data[key])
        }
      }
      // 控制导航 动画
      onGetType?.(item.type)
      if ([1, 2, 3, 4].includes(Number(item.type))) {
        // 已经进入到了最后一步
        if (data.content) {
          const decrypt = CommonFunc.decrypt(data.content)
          const content = JSON.parse(decrypt)
          data.steps.push(content)
        }
        sessionStore.set('stepData', data)
        const step = data?.steps
        const pathname = step[step.length - 1]?.pathname
        if (pathname == location.pathname) {
          // 通知正文页刷新其本地状态
          eventBus.emit('stepData-updated')
        }
        onCancel()
        history.push(pathname)
      } else if (item.type == 5) {
        if (data.content) {
          data.fileList = [JSON.parse(data.content)]
        }
        delete data.content
        const d = { ...data, ...data.steps }
        delete d.steps
        sessionStore.set('createPPTData', d)
        const pathname = data?.steps?.pathname
        if (pathname == location.pathname) {
          eventBus.emit('createPPTData-updated')
        }
        onCancel()
        history.push(pathname)
      } else if ([6, 7].includes(Number(item.type))) {
        const d = { ...data, ...data.steps }
        delete d.steps
        const pathname = data?.steps?.pathname
        if (pathname == location.pathname) {
          eventBus.emit('reduceData-updated')
        }
        sessionStore.set('reduceData', d)
        onCancel()
        history.push(pathname)
      } else if ([8].includes(Number(item.type))) {
        if (data.content) {
          data.fileList = [JSON.parse(data.content)]
        }
        delete data.content
        const d = { ...data, ...data.steps }
        delete d.steps
        const pathname = data?.steps?.pathname
        if (pathname == location.pathname) {
          eventBus.emit('layoutData-updated')
        }
        sessionStore.set('layoutData', d)
        onCancel()
        history.push(pathname)
      }
    }
  }

  const handleDelete = async (item: PaperItem) => {
    // ppt页
    let work_id = null
    if (['/createPPT', '/surePPTCatalog', '/selectPPTTheme', '/resulePPT'].includes(location.pathname)) {
      work_id = (sessionStore.get('createPPTData', '') as any)?.work_id
    } else {
      // 正文页
      work_id = (sessionStore.get('stepData', '') as any)?.work_id
    }
    if (work_id == item.work_id) {
      message.info('当前内容正在编辑，不能删除')
      return
    }
    const result: any = await sendRequest({
      method: 'post',
      url: 'work_delete',
      data: { token, work_id: item.work_id }
    })
    if (result?.res) {
      setData((prev: any) => ({
        ...prev,
        [activeTab]: prev[activeTab].filter((it: any) => it.work_id !== item.work_id)
      }))
    }
  }

  return (
    <BaseModal modalProps={{ open: visible, onCancel, onOk }} title={null} className='base-modal-bg-gradien LunwenManageModal'>
      <div className='LunwenManage-nav'>
        <h4>论文管理</h4>
        {TABS.map((tab, index) => (
          <Button
            key={tab.type}
            type='primary'
            className={`no-wave-button white-button ant${index} ${activeTab === tab.type ? 'active' : ''}`}
            onClick={() => handleTabChange(tab.type)}
          >
            {tab.label}
          </Button>
        ))}
      </div>
      <div className='base-modal-section'>
        <ul className='type-nav'>
          {TYPE_LIST.map(item => (
            <li key={item.value} className={activeType === item.type ? 'active' : ''} onClick={() => handleTypeChange(item.type)}>
              {item.label}
            </li>
          ))}
        </ul>
        <ul className='list'>
          {list.length > 0 ? (
            list.map((item: any, index: number) => (
              <li key={index}>
                <p className='title'>标题：{item.title}</p>
                <div className='info'>
                  <p className='left'>
                    <span>创建时间：{CommonFunc.timestampToTime(item.created_at, false, 'YYYY-MM-DD hh:mm')}</span>
                    <span>上次修改：{CommonFunc.timestampToTime(item.updated_at, false, 'YYYY-MM-DD hh:mm')}</span>
                  </p>
                  <p className='right'>
                    <span>类型：{DocTypeLabelMap[item.type]}</span>
                    <span>状态：{item.payment_state == 1 ? '已支付' : '未支付'}</span>
                  </p>
                </div>
                <div className='btns'>
                  <label onClick={() => handleContinueEdit(item)}>继续创作</label>
                  <BasePopconfirm popconfirmProps={{ title: '确认删除？', onConfirm: () => handleDelete(item) }}>
                    <label>删除</label>
                  </BasePopconfirm>
                </div>
              </li>
            ))
          ) : (
            <li className='list-no-data'>暂无数据</li>
          )}
        </ul>
      </div>
    </BaseModal>
  )
}

export default memo(withRouter(LunwenManage))
